/** Phase 7 shared helpers (post CP-10.4 refactor). */
import React from "react";

export function fmt(iso) {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleString(); } catch { return iso; }
}

export function money(amount, currency) {
  if (amount == null) return "—";
  const n = typeof amount === "string" ? parseFloat(amount) : amount;
  return `${currency || ""} ${n.toFixed(2)}`;
}

export function Stat({ label, value }) {
  return (
    <div>
      <div className="text-xs text-[var(--avcp-ink-soft)]">{label}</div>
      <div className="font-semibold">{value}</div>
    </div>
  );
}
